<div class="account-emails" *ngIf="emails">
  <div class="email-list">
    <div class="email-row" *ngFor="let email of emails">
      <strong>{{ email.email }}</strong>
      <aero-button
        *ngIf="!email.verified"
        [size]="ButtonSize.SLIM"
        [aeroStyle]="ButtonStyle.TEXT"
        [label]="'account_emails_verify' | translate"
        (onClick)="verify(email)">
      </aero-button>
      <span *ngIf="email.verified">{{ 'account_emails_verified' | translate }}</span>
      <input
        type="radio"
        name="defaultAccountEmail"
        [checked]="isDefault(email)"
        [attr.aria-label]="'account_settings_verify_email' | translate"
        (click)="setDefault(email)">
      <aero-button
        class="email-delete-button"
        [size]="ButtonSize.SLIM"
        [aeroStyle]="ButtonStyle.TEXT"
        styleClass="icon-only"
        icon="fas fa-trash-alt"
        [label]="'account_emails_delete_icon' | translate"
        [attr.aria-label]="'account_emails_delete_icon' | translate"
        [aeroTooltip]="canRemove(email) ? ('account_emails_delete' | transloco) : ('account_settings_disconnect_error_subscribed_unverified_body' | translate)"
        [disabled]="!canRemove(email)"
        (onClick)="remove(email)">
      </aero-button>
    </div>
  </div>
  <div class="email-actions">
    <aero-button
      [size]="ButtonSize.LARGER"
      [aeroStyle]="ButtonStyle.PRIMARY"
      [disabled]="!canAdd()"
      labelCode="account_emails_add"
      (onClick)="add()">
    </aero-button>
  </div>
</div>
